import React from 'react';
import styled from 'styled-components/macro';
import { copyFor } from '../../copy/copy';

const BackButtonContainer = styled.div`
    font-size: 12px;
    margin: 0.5rem 0 0.2rem;
    font-weight: bold;
    span {
        color: #008eff;
        font-weight: normal;
        cursor: pointer;
    }
`;

export default props => (
    <BackButtonContainer>
        {copyFor('postRecord', 'tryAgain', 'recordvideo')}
        <span onClick={props.onClick}>
            {' ' + copyFor('postRecord', 'tryAgainLink', 'recordvideo')}
        </span>
    </BackButtonContainer>
);
